export enum ACCOUNT_CONVERSION_STEPS {
  PAYMENT = 'payment',
  PLAN_DETAILS = 'plan-details',
  SUMMARY = 'summary',
  MANAGE_STORAGE = 'manage-storage',
}

export const STORAGE_LIMIT_MODIFIER = 'storage_limit';
export const ARCHIVED_STORAGE_LIMIT_MODIFIER = 'archived_storage_limit';
export const MOUNTED_STORAGE_LIMIT_MODIFIER = 'mounted_storage_limit';

/**
 * This is a list of vat eligible countries.
 * We will be exanding upon this list in the future.
 */
export const VAT_EXEMPT_ELIGIBLE_COUNTRIES = [
  {
    country: 'Denmark',
    code: 'DK',
  },
];
